export default __webpack_public_path__ + "static/media/image1.163f8b36.jpg";